import styled from 'styled-components';

export const GallerySlideWrapper = styled.div`
  height: 100%;
  position: relative;
  @media (min-width: 960px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

export const CardContainerMobile = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(
    to bottom,
    rgba(153, 153, 153, 0.2) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  backdrop-filter: blur(30px);
`;
